import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const AirplanemodeActiveIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"airplanemode_active"} ref={ref}/>
});

AirplanemodeActiveIcon.displayName = "AirplanemodeActiveIcon";
